import React, { useEffect, useState, useMemo } from 'react';
import { IonContent, IonAlert, IonPage } from '@ionic/react';
import './BasketPage.scss';

import BasketItemRow from '../components/BasketItemRow';
import { ApplicationState } from '../store';
import { useSelector, useDispatch } from 'react-redux';

import { bindActionCreators } from 'redux';
import * as BasketStore from '../store/BasketStore';

const BasketPage: React.FC = () => {
    const isColleagueDiscountBasket = useSelector((state: ApplicationState) => state.basket?.basket.isColleagueDiscountBasket);
    const externalPromotionsApplied = useSelector((state: ApplicationState) => state.basket?.basket.externalPromotionsApplied);
    const menuItems = useSelector((state: ApplicationState) => state.basket?.basket.menuItems);
    const [showAlert, setShowAlert] = useState(false);
    const boundClearBasket = bindActionCreators(BasketStore.actionCreators.clearBasket, useDispatch());
    const boundGetUpsells = bindActionCreators(BasketStore.actionCreators.getUpsells, useDispatch());
    const isColleague = useSelector((state: ApplicationState) => state.colleague?.isLoggedIn);

    useEffect(() => {
        console.log("Request upsells");
        boundGetUpsells();
    }, []);

    const sortedMenuItems = useMemo(() => {
        const sortedMenuItems: { [key: string]: IMopMenuItemDetail } = {};

        menuItems?.forEach(obj => {
            let key = "";

            if (obj.menuItemTotalPrice < 0) {
                key = obj.menuItemName + '_' + obj.menuItemTotalPrice;
            } else {
                key = obj.basketMenuItemId.toString();
            }

            if (sortedMenuItems[key]) {
                sortedMenuItems[key].quantity++;
            } else {
                sortedMenuItems[key] = { ...obj };
            }
        });

        return Object.values(sortedMenuItems);
    }, [menuItems]);

    return (
        <IonPage >

            <IonContent fullscreen class="BasketPage">
                <IonAlert
                    isOpen={showAlert}
                    onDidDismiss={() => { setShowAlert(false) }}
                    header={"Cancel Order"}
                    buttons={[
                        {
                            text: "No, don't cancel",
                            role: "cancel"
                        },
                        {
                            text: "Yes, cancel Order",
                            handler: () => {
                                boundClearBasket();
                            }
                        }
                    ]}
                    message={"Are you sure you want to cancel your order?"}
                />

                <IonContent className="ModalContent">
                    {isColleagueDiscountBasket && externalPromotionsApplied &&
                        <div className="MopBasketNotificationWrapper">
                            <div className="MopBasketNotification">Note: Your colleague discount will be recalculated at checkout</div>
                        </div>
                    }
                    {sortedMenuItems?.map((basketItem: IMopMenuItemDetail, index: number) => {
                        return <BasketItemRow
                            key={"basket_" + basketItem.basketMenuItemId}
                            basketItem={basketItem}
                            readOnly={false}
                            isColleague={isColleague}
                        />
                    })}
                </IonContent>

            </IonContent>
        </IonPage>
    );
};

export default BasketPage;
